/*
    Set iFrames source on document ready to avoid slowdowns
*/

jQuery(document).ready(function () {
    
    var
        iframes = jQuery('.iframe-async'),
        iframe
    ;
    
    iframes.each(function () {
        iframe = jQuery(this);
        iframe.prop('src', iframe.data('src'));
    });
    
});